import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdsSwiper from "../../Ads/components/detailComponents/AdsSwiper";
import { toCanvas } from "html-to-image";
import { addAppMessageListener, postToApp } from "../../../bridges/appBridge";
import axios from "axios";
import useStrictBackBlock from "../../../bridges/useStrictBackBlock";
import { useRecordsStore } from "../../../stores/useReordsStore";
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import close from "../../../assets/icons/System/close.svg";
import { Chip } from "../../../assets/components/Chip";
import SelectOptionButton from "../../AutoMarketing/components/detailComponents/SelectOptionButton";
import InstaTextArea from "../../AutoMarketing/components/detailComponents/InstaTextArea";
import { useFixedLayout } from "../../../hooks/useFixedLayout";
import { useToastOffset } from "../../../hooks/useToastOffset";
import TokenPopup from "../../Ads/components/detailComponents/TokenPopup";
import Popup from "../../../assets/components/PopupGroup";
import { TwinColumn, SplitRowHalf } from "../../../assets/components/ButtonGroup";
import checkOn from "../../../assets/icons/Select/check_checked.svg";
import checkOff from "../../../assets/icons/Select/check_unchecked.svg";
import retry from "../../../assets/icons/System/repeat_primary.svg";
import platformFromChannel from "../../../hooks/getPlatform";

const ManualMarketingCameraResult = () => {
  const location = useLocation();
  const { state, data, origin, userCopy = "", tokenAll = 0 } = location.state;
  const storeBusinessNumber = data.store_business_number;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [skipRegenPopup, setSkipRegenPopup] = useState(() => {
    try {
      const v = localStorage.getItem("re_popup");
      return v === "true";
    } catch {
      return false;
    }
  });

  const { headerRef, footerRef, headerSpace, bottomSpace } = useFixedLayout();
  const toastOffset = useToastOffset({
    footerRef,
    bottomSpace,
    gap: 8,
  });
  const addRecord = useRecordsStore((s) => s.addRecord);

  const channelToIdMap = {
    카카오톡: 1,
    "인스타 스토리": 2,
    인스타그램: 3,
    "인스타 게시물": 3,
    블로그: 4,
    네이버밴드: 6,
    "X(트위터)": 7,
  };

  const titleToIdMap = {
    "매장 홍보": 1,
    "상품 소개": 2,
    이벤트: 3,
  };

  let {
    origin_image,
    title,
    channel,
    copyright,
    custom_menu,
    core_f,
    store_name,
    road_name,
    main,
    detail_category_name,
    insta_copyright,
    style,
    prompt,
    filter_idx,
    event_title,
  } = state || {};

  if (title === "이벤트" && event_title !== "") {
    copyright = `제목 : ${event_title ?? ""} 내용 : ${copyright ?? ""}`;
  }

  const defaultChannel = channelToIdMap[channel] || "1";
  const defaultTitle = titleToIdMap[title] || "1";
  const imageSrc = `data:image/png;base64,${origin_image?.[0]}`;

  const [weekday, setWeekday] = useState("");
  useEffect(() => {
    const daysOfWeek = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
    const today = new Date().getDay();
    setWeekday(daysOfWeek[today]);
  }, []);

  const [, setSharePending] = useState(false);
  const [instaText, setInstaText] = useState(insta_copyright || "");
  const [checkImages, setCheckImages] = useState([]);
  const [regenWithSameOption, setRegenWithSameOption] = useState(() => {
    const key = `regen_same_option:${localStorage.getItem("user_id") || "guest"}`;
    try {
      const v = localStorage.getItem(key);
      return v === null ? true : v === "true";
    } catch {
      return true;
    }
  });
  const [popupOpen, setPopupOpen] = useState(false);
  const [noPopup, setNoPopup] = useState(false);
  const normalizedAiModel = location.state?.aiModel || null;

  useStrictBackBlock(true);

  useEffect(() => {
    const key = `regen_same_option:${localStorage.getItem("user_id") || "guest"}`;
    try {
      localStorage.setItem(key, String(regenWithSameOption));
    } catch {
      // ignore
    }
  }, [regenWithSameOption]);

  const handleImageClick = (index) => {
    setCheckImages([index]);
  };

  const handleTextChange = (e) => {
    setInstaText(e.target.value);
  };

  const returnHome = () => {
    navigate("/ads/main", { state: { storeBusinessNumber } });
  };

  const popupSubtitle = (
    <div className="space-y-1 text-b2">
      <p>이전 옵션 그대로 생성하시겠습니까? 옵션을 변경할 수도 있어요.</p>
      <p className="text-text-danger text-b2">* 이미지를 재생성할 경우 토큰이 차감됩니다.</p>
    </div>
  );

  const selectedTags = [
    { key: "age", prefix: "고객", label: core_f },
    { key: "channel", prefix: "채널", label: channel },
    { key: "title", prefix: "맞춤주제", label: title },
  ];

  const onUpload = async () => {
    setIsLoading(true);

    let useOptionPath = "";
    let titlePath = "";
    const normalizedTitle = String(title);
    const normalizedUseOption = String(channel);

    if (["1", "매장 홍보", "2", "상품 소개"].includes(normalizedTitle)) {
      titlePath = "intro";
    } else if (["3", "이벤트"].includes(normalizedTitle)) {
      titlePath = "event";
    }

    if (["1", "인스타스토리", "스토리", "인스타 스토리", "카카오톡", "2"].includes(normalizedUseOption)) {
      useOptionPath = "4to7";
    } else if (["3", "인스타그램", "인스타 게시물", "인스타", "피드", "블로그", "4", "5", "네이버밴드", "X(트위터)"].includes(normalizedUseOption)) {
      useOptionPath = "1to1";
    }

    const index = checkImages[0];
    if (index === undefined || index === null) {
      alert("템플릿이 적용된 이미지를 선택해 주세요.");
      setIsLoading(false);
      return;
    }

    let templateElement = null;
    let cursorElements = [];
    let editableElements = [];
    let imageData;

    try {
      if (index === 0) {
        imageData = imageSrc;
      } else {
        const key = `template_${titlePath}_${useOptionPath}_${index}`;
        templateElement = document.getElementById(key);
        if (!templateElement) {
          alert("템플릿 요소를 찾을 수 없습니다.");
          setIsLoading(false);
          return;
        }

        cursorElements = Array.from(templateElement.querySelectorAll(".blinking-cursor"));
        cursorElements.forEach((el) => {
          el.classList.remove("blinking-cursor");
          el.classList.add("no-blinking");
        });

        editableElements = Array.from(templateElement.querySelectorAll(".editable-text"));
        editableElements.forEach((el) => {
          el.setAttribute("data-prev-border", el.style.border || "");
          el.style.border = "none";
        });

        const exporter = window.__templateExports?.[key];
        if (typeof exporter === "function") {
          imageData = await exporter();
        } else {
          const w = templateElement.offsetWidth;
          const h = templateElement.offsetHeight;
          const canvas = await toCanvas(templateElement, {
            width: w * 2,
            height: h * 2,
            style: { transform: "scale(2)", transformOrigin: "top left" },
            cacheBust: true,
          });
          imageData = canvas.toDataURL("image/png", 1.0);
        }
      }

      const ageStr = core_f.match(/\d+/)?.[0];
      const styleMap = { "원본 사용": 7, "배경만 제거": 8, "배경 AI변경": 9, 필터: 10 };

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const date = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const manualDateTime = `${year}-${month}-${date} ${hours}:${minutes}`;
      const manualDateRange = [`${year}-${month}-${date}`, `${year}-${month}-${date}`];

      const userId = localStorage.getItem("user_id");
      const requestPayload = {
        title: String(defaultTitle),
        age: ageStr,
        style: `${styleMap[style]}`,
        channel: String(defaultChannel),
        repeat: "없음",
        date_range: manualDateRange,
        upload_time: `${hours}:${minutes}`,
        alert_check: false,
        user_id: userId,
        image: imageData,
        type: "manual",
        insta_copyright: instaText || "",
        copyright,
      };
      const requestId = Math.random().toString(36).slice(2);

      const response = await axios.post(
        `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/auto/app/save`,
        requestPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      const { success, imageUrl } = response.data || {};
      if (!success || !imageUrl) {
        alert("저장에 실패했습니다.");
        return;
      }

      addRecord({
        image_path: imageUrl,
        title: String(defaultTitle),
        age: typeof ageStr === "string" ? Number(ageStr) : ageStr,
        style: styleMap[style],
        channel: Number(defaultChannel),
        repeat_time: "없음",
        start_date: manualDateRange[0],
        end_date: manualDateRange[1],
        insta_copyright: instaText,
        copyright,
      });

      const platform = platformFromChannel(channel);
      let link = "";
      if (platform === "KAKAO") {
        const name = (localStorage.getItem("storeName") || "").trim();
        const region = (localStorage.getItem("roadName") || "").trim();
        if (name && region) {
          const label = `${region} ${name}`.trim();
          const long = `https://map.naver.com/p/search/${encodeURIComponent(label)}`;
          link = await axios
            .post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/g`, { url: long })
            .then((r) => r.data?.short || "")
            .catch(() => "");
        }
      }

      setSharePending(true);
      postToApp({
        type: "share.toChannel",
        requestId,
        social: platform,
        data: {
          imageUrl,
          caption: instaText || "",
          couponEnabled: false,
          ...(platform === "KAKAO" && link && { link }),
        },
      });

      if (!window.ReactNativeWebView) {
        navigate("/manual/marketing/final", {
          state: {
            image: imageData,
            selections: {
              title: String(defaultTitle),
              age: ageStr,
              channel: String(defaultChannel),
              style: `${styleMap[style]}`,
            },
            instaText: instaText || "",
            storeBusinessNumber,
            type: "manual",
            time: manualDateTime,
          },
        });
      }

      const off = addAppMessageListener((msg) => {
        if (msg?.type !== "SHARE_RESULT") return;
        if (msg?.payload?.platform && msg.payload.platform !== platform) return;

        off?.();
        setSharePending(false);

        const payload = msg.payload || {};
        const ok = payload.success === true;
        const errorCode = payload.error_code;
        const cancelled = payload.cancelled;

        if (ok) {
          navigate("/manual/marketing/final", {
            state: {
              image: imageData,
              selections: {
                title: String(defaultTitle),
                age: ageStr,
                channel: String(defaultChannel),
                style: `${styleMap[style]}`,
              },
              instaText: instaText || "",
              storeBusinessNumber,
              type: "manual",
              time: manualDateTime,
            },
          });
          return;
        }

        if (errorCode === "app_not_installed" || cancelled) {
          return;
        }

        alert("공유 중 오류가 발생했습니다. 다시 시도해 주세요.");
      });

      setTimeout(() => {
        off?.();
        setSharePending(false);
      }, 150000);
    } catch (error) {
      console.error("이미지 저장 또는 공유 실패:", error);
      alert("이미지 생성 중 오류가 발생했습니다.");
    } finally {
      cursorElements.forEach((el) => {
        el.classList.remove("no-blinking");
        el.classList.add("blinking-cursor");
      });

      editableElements.forEach((el) => {
        el.style.border = el.getAttribute("data-prev-border") || "";
        el.removeAttribute("data-prev-border");
      });

      setIsLoading(false);
    }
  };

  const onRegenStraight = () => {
    navigate("/manual/marketing/camera/loading", {
      state: {
        imageFile: origin instanceof File ? origin : null,
        imageUri: typeof origin === "string" ? origin : null,
        channel,
        title,
        age: core_f,
        style,
        bg_prompt: prompt,
        filter: filter_idx,
        aiModel: normalizedAiModel,
        custom_menu,
        category: data.detail_category_name || data.category,
        store_name: data.store_name,
        road_name: data.road_name,
        district_name: data.district_name,
        main: data.main,
        temp: data.temp,
        data,
        customText: userCopy,
      },
    });
  };

  const onRegenOption = () => {
    if (tokenAll <= 0) {
      setShowTokenModal(true);
      return;
    }

    const prev = {
      custom_menu,
      age: core_f,
      channel,
      theme: title,
      style,
      bg_prompt: prompt,
      filter: filter_idx,
      aiModel: normalizedAiModel,
    };

    navigate("/manual/marketing/gallery/regen", {
      state: {
        prev,
        data,
        state,
        origin,
        userCopy,
        isRegen: true,
      },
    });
  };

  const handleRegenClick = () => {
    if (tokenAll <= 0) {
      setShowTokenModal(true);
      return;
    }

    if (!regenWithSameOption) {
      onRegenOption();
      return;
    }

    if (skipRegenPopup) {
      onRegenStraight();
      return;
    }

    setPopupOpen(true);
  };

  const handleRegenConfirm = async () => {
    if (noPopup && !skipRegenPopup) {
      const userId = localStorage.getItem("user_id");
      if (userId) {
        try {
          await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/re_popup`, {
            user_id: userId,
            re_popup: true,
          });
          localStorage.setItem("re_popup", "true");
          setSkipRegenPopup(true);
        } catch (err) {
          console.log("re_popup save error", err);
        }
      }
    }

    if (regenWithSameOption) {
      onRegenStraight();
    } else {
      onRegenOption();
    }
    setPopupOpen(false);
  };

  return (
    <div className="h-dvh flex flex-col">
      <div ref={headerRef} className="fixed top-0 left-0 right-0 z-10">
        <HeaderIconL title="생성 완료" icon={close} onIconClick={returnHome} />
      </div>

      <div
        className="flex-1 px-[16px] overflow-y-auto"
        style={{ paddingTop: headerSpace, paddingBottom: bottomSpace }}
      >
        <div className="pt-[16px]">
          <h2 className="text-t2 text-text-default">완성했어요</h2>
          <p className="text-b2 text-text-subtler pt-[8px]">마음에 드는 이미지 1개를 저장해 보세요.</p>
        </div>

        <div className="pt-[24px]">
          <div className="w-full bg-surface-light-subtle p-[12px] pl-[16px] rounded-[16px]">
            <div className="flex items-center justify-between gap-[8px]">
              <div className="text-t4 text-text-subtle">옵션 설정</div>
              <Chip chip="d" status="selected" label="변경하기" onClick={onRegenOption} />
            </div>
            <SelectOptionButton selectedTags={selectedTags} />
          </div>
        </div>

        <AdsSwiper
          imageTemplateList={[imageSrc]}
          content={copyright.replace(/["']/g, "").trim()}
          title={defaultTitle}
          useOption={defaultChannel}
          checkImages={checkImages}
          handleImageClick={handleImageClick}
          storeName={store_name}
          roadName={road_name}
          weather={main}
          tag={detail_category_name}
          weekday={weekday}
          toastBottomOffset={toastOffset}
        />

        {instaText && (
          <InstaTextArea
            channel={channel}
            value={instaText}
            onChange={handleTextChange}
            toastBottomOffset={toastOffset}
          />
        )}
      </div>

      <TokenPopup isOpen={showTokenModal} onClose={() => setShowTokenModal(false)} />

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 z-10">
        <div className="px-[16px] pt-[12px] bg-surface-light-white">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              checked={regenWithSameOption}
              onChange={(e) => {
                setRegenWithSameOption(e.target.checked);
              }}
              className="sr-only"
            />
            <img
              src={regenWithSameOption ? checkOn : checkOff}
              alt={regenWithSameOption ? "옵션 그대로 다시 생성: 체크됨" : "옵션 그대로 다시 생성: 체크 안 됨"}
            />
            <span className="pl-[4px] text-b1 text-text-subtle">옵션 그대로 다시 생성</span>
          </label>
        </div>
        <SplitRowHalf
          leftText="다시 생성하기"
          rightText={isLoading ? "저장 중..." : "저장하기"}
          leftLeftIcon={retry}
          onLeft={handleRegenClick}
          onRight={isLoading ? undefined : onUpload}
          leftType="border"
          rightType={isLoading ? "gray" : "fill"}
          rightDisabled={isLoading}
        />
      </div>

      <Popup
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        title="다시 생성하기"
        subtitle={popupSubtitle}
        renderButtons={
          <>
            <button
              type="button"
              className="flex items-center p-[24px] pb-[16px]"
              onClick={() => setNoPopup((prev) => !prev)}
            >
              <img src={noPopup ? checkOn : checkOff} alt="" className="pr-[8px]" />
              <span
                data-nopopup={String(noPopup)}
                className={`text-b1 ${noPopup ? "text-text-default" : "text-text-disabled"}`}
              >
                다시 보지 않기
              </span>
            </button>
            <TwinColumn
              topType="fill"
              topText="다시 생성하기"
              onTop={handleRegenConfirm}
              bottomType="empty"
              bottomText="취소"
              onBottom={() => setPopupOpen(false)}
            />
          </>
        }
      />
    </div>
  );
};

export default ManualMarketingCameraResult;
